function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 85,
  cy: 85,
  r: 85,
  fill: "#FFEAE3"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 85.5821,
  cy: 86.7467,
  r: 65.7877,
  fill: "#FC8C66"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M86.32 102.656C84.208 102.656 82.416 101.984 80.944 100.64C79.536 99.232 78.832 97.216 78.832 94.592C78.832 91.968 79.344 89.824 80.368 88.16C81.456 86.432 83.12 84.48 85.36 82.304C87.792 79.936 89.648 77.696 90.928 75.584C92.208 73.472 92.848 70.688 92.848 67.232C92.848 64.992 92.24 63.296 91.024 62.144C89.872 60.992 88.496 60.416 86.896 60.416C85.552 60.416 84.4 60.8 83.44 61.568C82.48 62.336 82 63.36 82 64.64C82 65.6 82.192 66.496 82.576 67.328C83.024 68.096 83.792 68.896 84.88 69.728C84.304 71.136 83.344 72.224 82 72.992C80.72 73.76 79.312 74.144 77.776 74.144C75.664 74.144 73.84 73.504 72.304 72.224C70.768 70.88 70 69.056 70 66.752C70 63.488 71.76 60.896 75.28 58.976C78.864 56.992 83.088 56 87.952 56C93.52 56 97.872 57.12 101.008 59.36C104.144 61.536 105.712 64.8 105.712 69.152C105.712 71.456 105.296 73.536 104.464 75.392C103.696 77.184 102.768 78.752 101.68 80.096C100.592 81.376 99.12 82.944 97.264 84.8C95.152 86.848 93.584 88.608 92.56 90.08C91.536 91.488 91.024 93.056 91.024 94.784C91.024 96.256 91.536 98.08 92.56 100.256C90.576 101.856 88.496 102.656 86.32 102.656ZM86.128 122.048C83.568 122.048 81.648 121.472 80.368 120.32C79.088 119.168 78.448 117.504 78.448 115.328C78.448 110.848 81.008 108.608 86.128 108.608C88.624 108.608 90.512 109.184 91.792 110.336C93.072 111.488 93.712 113.152 93.712 115.328C93.712 117.504 93.072 119.168 91.792 120.32C90.512 121.472 88.624 122.048 86.128 122.048Z",
  fill: "white"
});

var SvgQuestion = function SvgQuestion(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 170,
    viewBox: "0 0 170 170",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQuestion, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/question.8163e4de.svg";
export { ForwardRef as ReactComponent };